import { Injectable } from '@angular/core';
import { IServerSideGetRowsRequest } from 'ag-grid-community';
import { Observable, map, of } from 'rxjs';

import { BaseService } from './base.service';
import { HttpService } from '../http.service';
import { NotificationService } from '../notification.service';
import { Search, SearchPage } from '../../models';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseEditService<T, TEdit> extends BaseService {
  protected constructor(
    protected baseRoute: string,
    public name: string,
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super(baseRoute, httpService);
  }

  search(
    search: string = undefined,
    id: string = undefined,
    id2: string = undefined,
    includeAll: boolean = false,
    allowIncludeAllBlankSearch = false,
    allowBlankSearch = true,
  ): Observable<T[]> {
    return this.searchPage(search, id, id2, includeAll, allowIncludeAllBlankSearch, allowBlankSearch).pipe(
      map((searchPage: SearchPage<T>) => searchPage.results),
    );
  }

  searchPage(
    search: string = undefined,
    id: string = undefined,
    id2: string = undefined,
    includeAll: boolean = false,
    allowIncludeAllBlankSearch = false,
    allowBlankSearch = true,
    serverSideSearch?: IServerSideGetRowsRequest,
  ): Observable<SearchPage<T>> {
    search = search?.trim();
    if (!search && !id && !id2 && (!allowBlankSearch || (includeAll && !allowIncludeAllBlankSearch))) {
      this.notificationService.fail($localize`Cannot search entire data without filters`);
      return of(<SearchPage<T>>{ results: [], count: 0 });
    }

    const model: Search = {
      search,
      id,
      id2,
      includeAll,
      serverSideSearch,
    };

    return this.httpService.post<SearchPage<T>>(`${this.apiUrl}/Search`, model);
  }

  create(parentId?: string, parentId2?: string): Observable<TEdit> {
    return of({} as TEdit);
  }

  edit(id: string): Observable<TEdit> {
    return this.httpService.get<TEdit>(`${this.apiUrl}/${id}`);
  }

  save(model: TEdit): Observable<string> {
    return this.httpService.post<string>(this.apiUrl, model);
  }

  delete(id: string): Observable<any> {
    return this.httpService.delete(`${this.apiUrl}/${id}`);
  }
}
